export const HttpHeaderKeys = {
    HTTP_HEADER_CONTENT_TYPE: 'Content-Type',
    HTTP_HEADER_AUTHORIZATION: 'Authorization',
    HTTP_HEADER_TOKEN: 'Token',
    HTTP_HEADER_MODULE_CODE: 'Module-Code',
    MIME_TYPE_JSON: 'application/json',
} as const;
